import React from 'react'
import { Container } from 'reactstrap';
import Link from 'components/Link';
import Img from 'gatsby-image';
import { FormattedMessage } from 'react-intl';

export default (props) => {

  const { content, data } = props;

  return (
    <div>

      <div className="wrapper">
        <Img sizes={data.img.childImageSharp.sizes}></Img>
      </div>

      <Container className="py-4">

        <div className="my-3">
          <h3 className="text-color-title">{content.title}</h3>
          <p>{content.headline}</p>
        </div>

        <div>
          <h4 className="text-color-subtitle">{content.subtitle}</h4>
          <p1>{content.p1}</p1>
          <p2>{content.p2}</p2>
          <p3>{content.p3}
            <Link to="/methods/biometrics"> {content.p3LinkText} </Link>
            {content.p3a}
          </p3>
        </div>

        <div className="text-center my-5">
          <Link className="btn btn-lg btn-success" to="/software/ocuchess">
            <FormattedMessage id="downloadOcuchess" /> <br />
            <FormattedMessage id="downloadOcuchessLine2" />
          </Link>
        </div>

      </Container>

    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/methods/personalized/_personalizedLayout.js